import controller from './language.controller';
import template from './language.html';
import './language.css';

const HealthcarebookLanguageComponent = {
    bindings: {
    },
    controller,
    template,
};

export default HealthcarebookLanguageComponent;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/language/language.component.js
// module id = 628
// module chunks = 0